import { createSlice } from "@reduxjs/toolkit";
import { WebPushState } from "shared/types/webPush";

const initialState: WebPushState = {
  popupType: null,
  user: null,
  firebaseLoaded: false,
  firebaseSendRequest: false,
};

const webPushSlice = createSlice({
  name: "webPush",
  initialState,
  reducers: {
    showPopup(state, { payload }) {
      state.popupType = payload.type;
      state.user = payload.user;
    },
    hidePopup(state) {
      state.popupType = null;
      state.user = null;
    },
    firebaseLoaded: (state, { payload }) => {
      state.firebaseLoaded = payload;
    },
    firebaseSend: (state, { payload }) => {
      state.firebaseSendRequest = payload;
    },
  },
});

export const { showPopup, hidePopup, firebaseLoaded, firebaseSend } =
  webPushSlice.actions;

export default webPushSlice.reducer;
